"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeQuery = void 0;
/**
 * Remove unexpected query parameters from incoming request. This should filter down
 * inbound searchParams to only include those specified by the page performing this operation.
 */
const sanitizeQuery = (req, acceptedParams) => {
    const { nextUrl } = req;
    const paramKeys = Array.from(nextUrl.searchParams.keys());
    const filteredParams = paramKeys.reduce((r, k) => {
        if (!acceptedParams.includes(k)) {
            nextUrl.searchParams.delete(k);
            r.push(k);
        }
        return r;
    }, []);
    return filteredParams.length !== 0;
};
exports.sanitizeQuery = sanitizeQuery;
exports.default = exports.sanitizeQuery;
